<nav (click)="navigate($event)">
  <table>
    <tr>
    <td id="logo">Lejdi Prifti</td>
    <td id="about" [ngClass] = "{'active':  selectedItem === 'about'}">
      <a [routerLink]="['/about']" routerLinkActive="active">About</a></td>
    <td [ngClass] = "{'active':  selectedItem === 'blog'}">
      <a [routerLink]="['/blog']" routerLinkActive="active">Blog</a></td>
    <td id="work" [ngClass] = "{'active':  selectedItem === 'work'}">
      <a [routerLink]="['/work']"routerLinkActive="active"> Work</a></td>
    <td [ngClass] = "{'active':  selectedItem === 'contact'}"><a [routerLink]="['/contact']" routerLinkActive="active">Contact</a></td>
    </tr>
  </table>
</nav>